import { useState } from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import "../css/footer.css";
import { Link } from "react-router-dom";
import salaryUncleLogo from "../images/salary_uncle_logo.png";

const IcoChevron = () => <svg className="su-foot-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>;

const IcoMapPin  = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>;
const IcoPhone   = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const IcoWhatsApp= () => <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.557 4.126 1.532 5.864L0 24l6.293-1.506A11.933 11.933 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.006-1.371l-.359-.214-3.732.893.924-3.638-.234-.374A9.818 9.818 0 1 1 12 21.818z"/></svg>;
const IcoMail    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;

const Footer = () => {
  const [openCol, setOpenCol] = useState(null);
  const toggle = (col) => setOpenCol((prev) => (prev === col ? null : col));

  return (
    <footer id="su-footer">
      <div className="su-footer-container">
        <div className="su-footer-grid">

          {/* COL 1 -- Brand */}
          <div className="su-footer-col su-footer-brand">
            <Link to="/" className="su-footer-logo-link">
              <img src={salaryUncleLogo} alt="Salary Uncle" className="su-footer-logo-img" />
            </Link>
            <p className="su-footer-about">
              Your trusted partner for emergency funds. We provide quick, collateral-free loans with transparent terms.
            </p>
            <div className="su-footer-socials">
              <a href="https://www.facebook.com/salaryuncle" className="su-social-icon" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://x.com/salaryuncle" className="su-social-icon" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://www.instagram.com/salaryuncle/" className="su-social-icon" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/salary-uncle/" className="su-social-icon" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            </div>
            <a href="https://play.google.com/store" className="su-gplay-badge" target="_blank" rel="noopener noreferrer">
              <svg width="28" height="28" viewBox="0 0 48 48"><path fill="#4db6ac" d="M7.705 4.043C7.292 4.259 7 4.718 7 5.318v37.364c0 .6.292 1.06.705 1.275l.339.15 20.93-20.929v-.494L8.044 3.893z"/><path fill="#dce775" d="M35.632 27.35l-6.97-6.971v-.494l6.971-6.97.157.089 8.255 4.689c2.358 1.339 2.358 3.527 0 4.866l-8.255 4.689z"/><path fill="#ef5350" d="M35.789 27.26L28.662 20.13 7.705 41.087c.779.827 2.067.927 3.519.103z"/><path fill="#81c784" d="M35.789 20.997L11.224 6.81C9.772 5.986 8.484 6.086 7.705 6.913l21.957 20.958z"/></svg>
              <div>
                <div className="su-gplay-top">GET IT ON</div>
                <div className="su-gplay-name">Google Play</div>
              </div>
            </a>
          </div>

          {/* COL 2 -- Quick Links */}
          <div className={`su-footer-col ${openCol === "quick" ? "su-foot-open" : ""}`}>
            <h4 className="su-footer-heading" onClick={() => toggle("quick")}>Quick Links <IcoChevron /></h4>
            <ul className="su-footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
            </ul>
          </div>

          {/* COL 3 -- Services */}
          <div className={`su-footer-col ${openCol === "services" ? "su-foot-open" : ""}`}>
            <h4 className="su-footer-heading" onClick={() => toggle("services")}>Services <IcoChevron /></h4>
            <ul className="su-footer-links">
              <li><Link to="/apply-now">Apply Now</Link></li>
              <li><Link to="/repay-loan">Pay Now</Link></li>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/rate-and-terms">Rate and Terms</Link></li>
            </ul>
          </div>

          {/* COL 4 -- Contact */}
          <div className={`su-footer-col ${openCol === "contact" ? "su-foot-open" : ""}`}>
            <h4 className="su-footer-heading" onClick={() => toggle("contact")}>Contact Us <IcoChevron /></h4>
            <ul className="su-footer-contact-list">
              <li>
                <span className="su-contact-icon"><IcoMapPin /></span>
                <span><strong>Registered Office:</strong><br />AG-52, shalimar bagh, delhi-110088</span>
              </li>
              <li>
                <span className="su-contact-icon"><IcoPhone /></span>
                {/* <a href="tel:+918448980504">+91 8448980504</a> */}
                {/* <a href="tel:+918130109457">+91 8130109457</a> */}
                {/* <a href="tel:+917428966221">+91 7428966221</a> */}
                <a href="tel:+917042561004">+91 7042561004</a>
              </li>
              <li>
                <span className="su-contact-icon"><IcoWhatsApp /></span>
                <span>
                  <a href="https://wa.me/917428966114" target="_blank" rel="noopener noreferrer">+91 7428966114</a>
                  {/* <a href="tel:+917428966114">+91 7428966114</a><br />
                  <a href="tel:+918796041166">+91 8796041166</a> */}
                </span>
              </li>
              <li>
                <span className="su-contact-icon"><IcoMail /></span>
                <a href="mailto:Customercare@salaryuncle.com">Customercare@salaryuncle.com</a>
              </li>
            </ul>

          </div>

        </div>

        {/* FOOTER BOTTOM */}
        <div className="su-footer-bottom">
          <p>Copyright &copy; RBI Registered NBFC Julania Finance Pvt Ltd - RBI Registered NBFC (Reg. No. B-14.01650)</p>
          <div className="su-footer-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
